import React from "react";
import clsx from "clsx";

interface DynamicIconProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  url?: string;
  fallbackSrc?: string;
  isLoading?: boolean;
}

const DynamicIcon: React.FC<DynamicIconProps> = ({ url, fallbackSrc, className, isLoading, ...props }) => {
  if (isLoading) {
    return (
      <div 
          className={clsx(
            "animate-pulse bg-gray-200 rounded-md",
            className
          )}
        style={{ width: "50px", height: "50px" }} 
      />
    );
  }

  const imageSrc = url || fallbackSrc;

  if (!imageSrc) return null;

  return (
    <img 
      src={imageSrc} 
      className={clsx(
        "object-contain",
        className
      )}
      {...props}
    />
  );
};

export default DynamicIcon;
